<template lang="pug">
b-btn.float-right(
  v-if='target && canWatchNow( target )'
  variant='primary'
  size='lg'
  :to='target.path'
) {{ sayAction( target )}} now
b-btn.watch.subscribe-to-watch(
  v-else-if='needsSubscription( target )'
  size='lg'
  variant='warning'
  :to="target.preview ||{ path: '/members', query: { then: target.path }}"
) subscribe to {{ sayAction( target ) }}
</template>

<script lang="js">
import mediaActions from '@/mixins/media-actions'

export default {
  name: 'watch-button',
  mixins: [ mediaActions ],
  components: {},
  props: [ 'target' ],
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.watch-buttton {

}
</style>
